import { Box, Text } from "@chakra-ui/react";

const Diviser = ({ titulo }: any) => {
  return (
    <Box paddingTop="20px" position="relative">
      <hr />
      <Text
        color="gray.600"
        fontWeight="bold"
        position="absolute"
        background="white"
        padding="0 8px"
        top="8px"
        left="10px"
      >
        {titulo}
      </Text>
    </Box>
  );
};

export default Diviser;
